import React, { useEffect, useRef, useState } from "react";
import styles from "./MyBalance.module.scss";
// import giftIcon from "../../../assets/images/packages/Gift.svg";
import MyBalanceHeader from "../../../components/pages/admin-panels/my-balance/my-balance-header/MyBalanceHeader";
import BalanceTopUp from "../../../components/pages/admin-panels/my-balance/balance-top-up/BalanceTopUp";
import BalanceHistory from "../../../components/pages/admin-panels/my-balance/balance-history/BalanceHistory";
import BalanceModal from "../../../components/pages/admin-panels/my-balance/balance-modal/BalanceModal";
import { BalanceServices } from "../../../services/balance.service";
import {
  BalanceHistoryDataType,
  BalanceInfoType,
} from "../../../interface/site.interface";
import Spinner from "../../../components/shared/spinner/Spinner";
import { useLocation } from "react-router-dom";
import TitleUpdater from "../../../components/shared/title/TitleUpdater";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { fetchTranslation } from "../../../redux/Slices/translationDataSlice";

export default function MyBalance() {
  const language = useSelector((state: RootState) => state.language.language);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const { data } = useSelector((state: RootState) => state.translationData);
  const dispatch = useDispatch<AppDispatch>();

  const [myBalance, setMybalance] = useState<BalanceInfoType>({
    balance: "",
    get_page: {
      add_balance: "",
      balance_log: "",
      balance_text: "",
      add_balance_save: "",
      balance: "",
      amount: "",
    },
  });
  const [balanceHistory, setBalanceHistory] = useState<
    BalanceHistoryDataType[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [loadingBalance, setLoadingBalance] = useState(false);
  const location = useLocation();
  const debt = location.state?.debt || "";
  useEffect(() => {
    setLoadingBalance(true);
    BalanceServices.getMyBalance()
      .then((res) => {
        setMybalance(res.data);
      })
      .catch(() => console.log("err"))
      .finally(() => setLoadingBalance(false));
  }, [language]);

  useEffect(() => {
    setLoading(true);
    BalanceServices.getBalanceHistory()
      .then((res) => {
        setBalanceHistory(res.data.logs);
      })
      .catch(() => console.log("err"))
      .finally(() => setLoading(false));
  }, [language]);

  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      if (!data) {
        dispatch(fetchTranslation());
      }
    } else {
      dispatch(fetchTranslation());
    }
  }, [dispatch, language]);

  return (
    <div>
      <TitleUpdater
        title={
          data?.colibri && data?.auth_my_balance
            ? `${data?.colibri} | ${data?.auth_my_balance}`
            : "Colibri"
        }
      />
      {loadingBalance ? (
        <Spinner size="large" />
      ) : (
        <>
          <div className={styles.balance_overview_container}>
            <MyBalanceHeader myBalance={myBalance} />

            <div className={styles.balance_note_container}>
              <p className={styles.balance_note_title}>
                {data?.auth_common_note}
              </p>
              <p
                className={styles.balance_note_description}
                dangerouslySetInnerHTML={{
                  __html: (myBalance?.get_page?.balance_text || "").replace(
                    /\n/g,
                    "<br />"
                  ),
                }}
              />
            </div>

            <BalanceTopUp
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              isSuccess={isSuccess}
              setIsSuccess={setIsSuccess}
              defaultAmount={debt}
              myBalance={myBalance}
            />
          </div>
          {loading ? (
            <Spinner size="large" />
          ) : (
            <BalanceHistory
              balanceHistory={balanceHistory}
              myBalance={myBalance}
            />
          )}

          <BalanceModal
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            isSuccess={isSuccess}
          />
        </>
      )}
    </div>
  );
}
